import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-plus",
  "use": "icon-ib-plus-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-plus\">\n    <path d=\"M513.536 128c26.453333 0 47.957333 21.546667 47.914667 48.042667l-0.384 287.957333h286.933333a48 48 0 0 1 0 96h-287.061333l-0.341334 288.085333a48 48 0 0 1-96-0.128l0.341334-287.957333H176a48 48 0 0 1 0-96H465.066667l0.426666-288.042667c0-26.538667 21.504-48 48.042667-47.957333z\" p-id=\"5082\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol